<template>
<div class="app-wrapper">
  <template v-if="user">
    <router-view></router-view>
  </template>
</div>
</template>

<script>
export default {
  name: "FullSecurityLayout",
  data() {
    return {}
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
  },
  created() {
    let that = this
    //  验证是否登录
    let loadingInstance = that.$loading()
    that.$store.dispatch('auth/autoLogin').then(() => {
      loadingInstance.close()
    }).catch((err) => {
      console.log(err)
      loadingInstance.close()
      that.$router.push({path: '/login'})
    })
  },
}
</script>

<style scoped>

</style>
